export const PAGE = {
  DEFAULT: "/",
  SERVICESPAGE: "/services/:slug",
  ABOUTPAGE: "/aboutus",
  CONTACTPAGE: "/contact",
  NOTFOUND: "*",
} as const;

/** Build a concrete service URL from a slug. */
export const buildServiceUrl = (slug: string) => `/services/${slug}`;
